













































































































import {
  defineComponent,
  computed,
  ref,
  reactive,
  watch
} from "@vue/composition-api";
import { getManagedPartnerUsers, deleteManagedPartnerUser } from "@/api";
import { useRequest } from "@/helpers/hooks/useRequest";
import { useToggle } from "@/helpers/hooks/useToggle";

import Layout from "@/components/Atoms/Layout/index.vue";
import SettingBreadcrumbs from "@/components/Pages/Accounts/Molecules/SettingBreadcrumbs/index.vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import OccHeading from "@/components/Atoms/OccHeading/index.vue";
import Button from "@/components/Atoms/Button/index.vue";
import Caption from "@/components/Atoms/Typography/Caption/index.vue";
import ListTable, {
  Props as TableProps
} from "@/components/Molecules/ListTable/index.vue";
import LoadingView from "@/components/Molecules/LoadingView/index.vue";
import MenuDropdown from "@/components/Molecules/MenuDropdown/index.vue";
import OccModal from "@/components/Atoms/OccModal/index.vue";
import OccToast from "@/components/Atoms/OccToast/index.vue";
import OccButton from "@/components/Atoms/OccButton/index.vue";
import ConfirmModal from "@/components/Organisms/modals/ConfirmModal/index.vue";
import { useStore } from "@/store";
import { useRouter } from "@/router";

interface ClickedPartnerUser {
  id: number | undefined;
  name: string | undefined;
}

export default defineComponent({
  name: "AccountsPartnerUsers",
  components: {
    Layout,
    SettingBreadcrumbs,
    OccHeading,
    Heading,
    Button,
    Caption,
    LoadingView,
    ListTable,
    MenuDropdown,
    OccModal,
    OccButton,
    ConfirmModal,
    OccToast
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const currentPartnerUser = store.state.domains.user.partnerUser;
    const clickedPartnerUser = reactive<ClickedPartnerUser>({
      name: "",
      id: -1
    });
    let hasDeletedManagedPartnerUser = false;
    const [
      isShowDeletePartnerUserModal,
      toggleDeletePartnerUserModal
    ] = useToggle(false);
    const [
      { data: partnerUsers, loading: loading },
      runGetPartnerUsers
    ] = useRequest(() => getManagedPartnerUsers(), {
      immediate: true
    });

    const mouseoverMenu = ref(false);

    const headers = ref<TableProps["headers"]>([
      {
        name: "名前",
        subHeaders: [{ name: "メールアドレス" }],
        minSizeContainer: "750px"
      },
      {
        name: "権限",
        minSizeContainer: "50px"
      },
      {
        name: "", // action area
        minSizeContainer: "40px"
      }
    ]);

    const tableRows = computed(() => {
      return partnerUsers.value;
    });

    const tableMenuDropDownList = [
      { value: "edit", label: "編集" },
      { value: "delete", label: "削除" }
    ] as const;

    const loggedInPartnerUserMenu = tableMenuDropDownList.filter(
      item => item.value !== "delete"
    );

    const showMenu = (id: number) => {
      if (currentPartnerUser !== undefined && currentPartnerUser.id === id) {
        return loggedInPartnerUserMenu;
      } else {
        return [...tableMenuDropDownList];
      }
    };

    const toastInfo = reactive({
      isVisible: false,
      toastText: "ユーザーを削除しました"
    });

    const closeToast = () => {
      toastInfo.isVisible = false;
    };

    const showToast = () => {
      toastInfo.isVisible = true;
    };

    const autoCloseToast = (closeToastFunc: () => void) => {
      setTimeout(() => {
        closeToastFunc();
      }, 10000);
    };

    type DropDownValue = typeof tableMenuDropDownList[number]["value"];

    const onClickTableMenu = (value: DropDownValue, rowIndex: number) => {
      const partnerUserId = tableRows.value?.[rowIndex].id;
      switch (value) {
        case "delete":
          clickedPartnerUser.name = tableRows.value?.[rowIndex].name;
          clickedPartnerUser.id = partnerUserId;
          toggleDeletePartnerUserModal();
          break;
        default:
          router
            .push({
              name: "AccountsPartnerUsersEdit",
              params: { partnerUserId: `${partnerUserId}` }
            })
            .catch(err => err);
      }
    };
    const onClickRow = (value: DropDownValue, rowIndex: number) => {
      if (mouseoverMenu.value) {
        return;
      }
      onClickTableMenu(value, rowIndex);
    };

    const handleClickDelete = async (partnerUserId: number) => {
      const [{ error: error }, runDeletePartnerUser] = useRequest(() =>
        deleteManagedPartnerUser({ partner_user_id: partnerUserId })
      );
      if (!error) return;
      await runDeletePartnerUser();
      hasDeletedManagedPartnerUser = true;
      await runGetPartnerUsers();
    };

    watch(loading, (now, pre) => {
      if (!!pre && !!!now && hasDeletedManagedPartnerUser) {
        hasDeletedManagedPartnerUser = false;
        showToast();
        autoCloseToast(closeToast);
      }
    });

    const confirmDeletePartnerUserModal = (partnerUserId: number) => {
      toggleDeletePartnerUserModal();
      handleClickDelete(partnerUserId);
    };

    const handleClick = () =>
      router.push({ name: "AccountsPartnerUsersNew" }).catch(err => err);

    return {
      loading,
      mouseoverMenu,
      headers,
      tableRows,
      tableMenuDropDownList,
      onClickTableMenu,
      onClickRow,
      handleClickDelete,
      handleClick,
      showMenu,
      isShowDeletePartnerUserModal,
      toggleDeletePartnerUserModal,
      confirmDeletePartnerUserModal,
      clickedPartnerUser,
      toastInfo,
      closeToast,
      showToast
    };
  }
});
